import { Component } from '@angular/core';

import { ParcelModel } from '@app/common/models/parcel.model';
import { TooltipAbstractListComponent } from '../tooltip-abstract-list/tooltip-abstract-list.component';

@Component({
  selector: 'tooltip-parcels',
  templateUrl: './tooltip-parcels.component.html',
  styleUrls: ['./tooltip-parcels.component.scss'],
})
export class TooltipParcelsComponent extends TooltipAbstractListComponent<ParcelModel> {
  protected resource = 'parcels';

  ngOnInit() {
    super.ngOnInit();
  }

  getDoneParcels(): {parcel: ParcelModel, titleId: number}[] {
    return this.mapParcelIds(this.data.customData.doneParcelIds);
  }

  getNotStartedParcels(): {parcel: ParcelModel, titleId: number}[] {
    return this.mapParcelIds(this.data.customData.notStartedParcelIds);
  }

  getInProgressParcels(): {parcel: ParcelModel, titleId: number}[] {
    return this.mapParcelIds(this.data.customData.inProgressParcelIds);
  }

  mapParcelIds(ids: any[]) {
    return this.data.list && ids.map((ids) => {
          const parcel: ParcelModel = this.data.list.list.find(i => i.id === ids.parcelId);
          if (parcel) {
            return {
              parcel: parcel,
              titleId: ids.titleId,
            };
          }
        }).filter(i => i);
  }
}

